import axios from "axios";
import Vue from "vue";

const URL = process.env.VUE_APP_API;

const FETCH_TEST = "FETCH_TEST";
const SET_TEST_TRANSLATION = "SET_TEST_TRANSLATION";
const FETCH_TEST_SUCCESS = "FETCH_TEST_SUCCESS";

const defaultState = {
  pending: false,
  translation: false,
  translation_language: null,
};
const mutations = {
  [FETCH_TEST](state) {
    state.pending = true;
  },
  [SET_TEST_TRANSLATION](state, payload) {
    Vue.set(state, "translation", payload);
  },
  [FETCH_TEST_SUCCESS](state, payload) {
    Object.keys(payload).forEach((key) => {
      Vue.set(state, key, payload[key]);
    });
  },
};

const actions = {
  fetchTest({ state, commit, rootState }, id) {
    return new Promise((resolve) => {
      axios
        .get(`${URL}/tests/${id}`)
        .then((res) => {
          commit(FETCH_TEST_SUCCESS, res.data);
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    });
  },
};

const getters = {
  getState: (state) => {
    return () => state;
  },
};

export default {
  state: defaultState,
  getters,
  actions,
  mutations,
};
